if (!customElements.get('bitterclub-points-slider')) {
  class BitterclubPointsSlider extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="range"]');
      if (!this.input) return;

      const wrapper = this.closest('.bitterclub-points-converter');
      this.pointsOutput = wrapper?.querySelector('[data-points-output]');
      this.discountOutput = wrapper?.querySelector('[data-discount-output]');
      this.pointsPerEuro = Number(this.dataset.pointsPerEuro) || 100;

      this.abortController = new AbortController();
      this.input.addEventListener('input', () => this.update(), {
        signal: this.abortController.signal,
      });

      this.update();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    update() {
      const points = Number(this.input.value);
      const discount = points / this.pointsPerEuro;

      if (this.pointsOutput) {
        this.pointsOutput.textContent = points.toLocaleString('de-DE');
      }

      if (this.discountOutput) {
        this.discountOutput.textContent = `${discount.toLocaleString('de-DE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} €`;
      }
    }
  }

  customElements.define('bitterclub-points-slider', BitterclubPointsSlider);
}
